// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop-search {
  display: none;
}

.mobile-search-toolbar {
  display: block;
}

.mobile-search {
  width: 100%;
}

@media (max-width: 767px) {
  ion-buttons[slot=start] {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }
  ion-buttons[slot=end] {
    flex: 0 0 auto;
  }
  .header-page-icon,
  .header-page-title,
  .header-page-title__beta {
    flex: 0 0 auto;
  }
  .header-page-title {
    min-width: 0;
    flex: 1 1 auto;
  }
  .header-page-title__text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-mobile-hidden {
    display: none;
  }
}
@media (min-width: 768px) {
  .desktop-search {
    display: block;
  }
  .mobile-search-toolbar {
    display: none;
  }
  ion-buttons[slot=end] app-search-component {
    --app-search-width: 21rem;
    --app-search-min-width: 21rem;
  }
}
.ai-chat-bottone {
  --border-radius: 10px;
  --padding-start: 6px;
  --padding-end: 6px;
}
.ai-chat-bottone ion-icon {
  font-size: 26px;
}

.ai-chat-bottone--aperto {
  --background: rgba(var(--ion-color-light-rgb), 0.18);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/header/user-header/user-header.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE;IACE,cAAA;IACA,YAAA;IACA,gBAAA;EACF;EAEA;IACE,cAAA;EAAF;EAGA;;;IAGE,cAAA;EADF;EAIA;IACE,YAAA;IACA,cAAA;EAFF;EAKA;IACE,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAHF;EAMA;IACE,aAAA;EAJF;AACF;AAOA;EACE;IACE,cAAA;EALF;EAQA;IACE,aAAA;EANF;EASA;IACE,yBAAA;IACA,6BAAA;EAPF;AACF;AAWA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;AATF;AAWE;EACE,eAAA;AATJ;;AAcA;EACE,oDAAA;AAXF","sourcesContent":[".desktop-search {\n  display: none;\n}\n\n.mobile-search-toolbar {\n  display: block;\n}\n\n.mobile-search {\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  ion-buttons[slot='start'] {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  ion-buttons[slot='end'] {\n    flex: 0 0 auto;\n  }\n\n  .header-page-icon,\n  .header-page-title,\n  .header-page-title__beta {\n    flex: 0 0 auto;\n  }\n\n  .header-page-title {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .header-page-title__text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .header-mobile-hidden {\n    display: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .desktop-search {\n    display: block;\n  }\n\n  .mobile-search-toolbar {\n    display: none;\n  }\n\n  ion-buttons[slot='end'] app-search-component {\n    --app-search-width: 21rem;\n    --app-search-min-width: 21rem;\n  }\n}\n\n// Feature 159: bottone dell'assistente, sola icona come gli altri dell'header.\n.ai-chat-bottone {\n  --border-radius: 10px;\n  --padding-start: 6px;\n  --padding-end: 6px;\n\n  ion-icon {\n    font-size: 26px;\n  }\n}\n\n// Pannello aperto: lo stesso bottone resta evidenziato, senza contorno.\n.ai-chat-bottone--aperto {\n  --background: rgba(var(--ion-color-light-rgb), 0.18);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
